import FastImage from 'react-native-fast-image'

export const Image = FastImage
